/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Hold_Create_FailedInputs */

const en_inventory_hold_create_failed = /** @type {(inputs: Inventory_Hold_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create hold`)
};

const es_inventory_hold_create_failed = /** @type {(inputs: Inventory_Hold_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo crear el apartado`)
};

/**
* | output |
* | --- |
* | "Failed to create hold" |
*
* @param {Inventory_Hold_Create_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_hold_create_failed = /** @type {((inputs?: Inventory_Hold_Create_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Hold_Create_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_hold_create_failed(inputs)
	return es_inventory_hold_create_failed(inputs)
});